import { all, call, put } from 'redux-saga/effects';

import {
  factorLogic,
  factorLogicFailure,
  factorLogicSuccess,
} from '../handoff-hub.action';
import { CategoryName, FactorName, FactorTest } from '../handoff-hub.reducer';
import {
  checkReviewSolicitations,
  checkMissedCallSMS,
} from './premium-features.action-helpers';

export const CATEGORY: CategoryName = 'premiumFeaturesCategory';

export const handleLogic = function* (factorName: FactorName, func: () => any) {
  yield put(factorLogic({ category: CATEGORY, factorName }));
  try {
    const { status, tests } = yield call(func);

    yield put(
      factorLogicSuccess({
        category: CATEGORY,
        factorName,
        status,
        tests,
      })
    );
  } catch (error: any) {
    const tests: FactorTest[] = [
      {
        name: factorName,
        actual: `${error}`,
        status: '',
      },
    ];
    yield put(
      factorLogicFailure({
        category: CATEGORY,
        factorName,
        tests,
      })
    );
  }
};

export const handlePremiumFeaturesLogic = function* () {
  yield all([
    call(handleLogic, 'reviewsEnabled', checkReviewSolicitations),
    call(handleLogic, 'missedCallSMS', checkMissedCallSMS),
  ]);
};
